import frMessages from './locales/fr_CA';

export interface IMessage {
  messages: Record<string, any>;
  locale: any;
}

export interface LocaleConfig {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: IMessage;
}

// https://www.keypup.io/blog/react-extend-react-intl-with-our-own-context-and-markup
// https://formatjs.io/docs/getting-started/installation
const appLocales: LocaleConfig = {
  fr: {
    messages: frMessages,
    locale: 'fr-CA',
  },
};

export default appLocales;
